import React from "react";
import { data } from "./Data";
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import GridAnimation from "../GridAnimation/Grid";

import image1 from "../../Assets/Background/image1.png";
import image2 from "../../Assets/Background/image2.png";
import image3 from "../../Assets/Background/image3.png";

export const Custom = () => {
  const business = [
    { text: "Large payments volume", image: image1 },
    { text: "High value transactions", image: image3 },
    { text: "Unique business models", image: image2 },
  ];

  return (
    <section className="px-6 mb-32 text-center text-white md:px-0 bg-[#010f24] h-max overflow-hidden md:bg-transparent">
      <div className="relative py-8 max-w-7xl mx-auto bg-transparent md:bg-[#010f24] overflow-hidden md:py-24 md:rounded-[40px]">
        <div className="absolute left-0 top-0 h-full">
          <GridAnimation />
        </div>
        <h2 className="text-center text-2xl font-semibold md:text-4xl md:leading-[3.4rem]">
          Get a custom price
        </h2>
        <p className="hidden md:block">
          Get volume discount and country specific rates. <br /> Available for
          business with:
        </p>

        <p className="px-4 md:hidden">
          Get volume discount and country specific rates. Available for business
          with:
        </p>
        <div className="px-2 grid grid-cols-1 gap-3 mt-5 md:grid-cols-3 mx-auto md:w-1/2">
          {business.map((item, i) => {
            return (
              <div className="relative w-56 mx-auto md:w-auto" key={i}>
                <img src={item.image} alt=""/>
                <div className="absolute left-0 bottom-1 px-10 mx-auto w-full md:px-3">
                  <p className="text-center">{item.text}</p>
                </div>
              </div>
            );
          })}
        </div>
        <button className="mt-8 bg-brandColor text-white py-3 px-16 rounded-full font-semibold md:mt-16">
          Contact Sales
        </button>
      </div>
    </section>
  );
};

const Included = () => {
  const [id, setId] = useState(0);
  return (
    <section className="my-16 md:mb-32">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center text-2xl font-semibold md:text-4xl md:leading-[3.4rem]">
          What's included
        </h2>
        <div className="mt-10 grid grid-cols-1 gap-10 md:grid-cols-3 w-max mx-auto">
          {data.map((item, i) => (
            <div key={i} className="space-y-3">
              <item.image className="object-cover rounded-full text-brandColor !text-3xl" />
              <h2 className="font-[600] text-[20px]">{item.title}</h2>
              <div className="relative list-disc space-y-3">
                {item.description.map((listItem, i) => (
                  <ul className="list relative" key={i}>
                    <div className="flex flex-row items-center gap-2">
                      <CheckIcon className="!text-xl !text-gray-500" />
                      <li
                        onMouseOver={() => setId(listItem.id)}
                        onMouseLeave={() => setId(0)}
                        className="text-gray-700 relative hover:text-brandColor duration-500 cursor-pointer"
                      >
                        {listItem.text}
                      </li>
                    </div>
                    <p
                      className={`text-gray-500 absolute bg-white ${
                        listItem.text.length > 45 ? `-top-20` : `-top-14`
                      } -left-10 w-full shadow-2xl py-3 px-4 rounded-lg duration-700 ${
                        id === listItem.id ? `block` : `hidden`
                      } z-50`}
                    >
                      {listItem.text}
                      <span className="absolute bg-white left-3 -bottom-2 p-2 rounded-l-full shadow-2xl" />
                    </p>
                  </ul>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="text-center">
          <button className="mt-16 bg-brandColor text-white py-3 px-16 rounded-full font-semibold">
            Create a free account
          </button>
        </div>
      </div>
    </section>
  );
};

export default Included;
